import { useState } from 'react'

function EditProfile() {
    const [image, setImage] = useState({ preview: "", raw: "" });

    const handleChange = e => {
        if (e.target.files.length) {
            setImage({
                preview: URL.createObjectURL(e.target.files[0])
            });
        }
    };



    return (
        <section className="registration_page page_padding ss_page auth_page">
            <div className="container">
                <div className="ph_wrapper">
                    <h1 className="page_heading">প্রোফাইল এডিট করুন</h1>
                </div>
                <div className="from_wrapper">
                    <form action="/" className='custom_form'>
                        <div className="input_group upload_picture">
                            <label htmlFor="fileUpload">
                                {image.preview ? (
                                    <img src={image.preview} alt="upload-icon" />
                                ) : (
                                    <img src={require('../../../Assets/images/profile-pic.png')} alt="upload-icon" />
                                )}
                                <div className="edit-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                        <path d="M7.37333 4.01333L7.98667 4.62667L1.94667 10.6667H1.33333V10.0533L7.37333 4.01333ZM9.77333 0C9.60667 0 9.43333 0.0666666 9.30667 0.193333L8.08667 1.41333L10.5867 3.91333L11.8067 2.69333C12.0667 2.43333 12.0667 2.01333 11.8067 1.75333L10.2467 0.193333C10.1133 0.06 9.94667 0 9.77333 0ZM7.37333 2.12667L0 9.5V12H2.5L9.87333 4.62667L7.37333 2.12667Z" fill="white"></path>
                                    </svg>
                                </div>
                            </label>
                            <input type="file" accept="image/*" id='fileUpload' onChange={handleChange} />
                        </div>
                        <div className="input_group">
                            <label htmlFor="">আপনার ফার্স্ট নেম</label>
                            <input type="text" placeholder='আপনার ফার্স্ট নেম' />
                        </div>
                        <div className="input_group">
                            <label htmlFor="">আপনার লাস্ট নেম</label>
                            <input type="text" placeholder='আপনার লাস্ট নেম' />
                        </div>
                        <div className="input_group">
                            <label htmlFor="">আপনার ইমেইল</label>
                            <input type="email" placeholder='আপনার ইমেইল' />
                        </div>
                        <div className="input_group">
                            <label htmlFor="">আপনার ফোন নাম্বার</label>
                            <input type="text" placeholder='আপনার ফোন নাম্বার' />
                        </div>
                        <button type='submit' className='btn_submit'>সেভ করুন</button>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default EditProfile